import { useFetch } from '@/core/hooks/useFetch';
import { ApiResource } from '@future-harry/nxt-styles';
import { Language } from '@future-harry/nxt-vue-library';
import { LANGUAGE_ENDPOINTS } from './languages.endpoints';

export const getLanguages = async () => {
   const { data: languagesData } = await useFetch<ApiResource<Language[]>>(LANGUAGE_ENDPOINTS.GET_ALL());

   return languagesData.value?.data ?? [];
};
